// Segmento da oficina (carro | moto) para as telas do Painel de Gestao.
//
// De onde vem: o components/Layout.js -- que TODA pagina do painel renderiza
// -- ja buscava `oficina_config_<tenant>` a cada carregamento. E a MESMA
// chave que o ChecklistConfigGate le para o modulo de Checklist, e o
// `segmento` ja vinha dentro dela. O Layout aproveitava so `modulosAtivos` e
// jogava o resto fora. A partir daqui ele guarda o segmento tambem -- sem
// requisicao nova, sem provider novo, sem alterar a arvore de rotas.
//
// Por que localStorage e nao contexto: as paginas ficam FORA do
// WorkshopProvider (so o /checklist passa por ele), e criar um provider novo
// envolvendo o app inteiro seria reestruturar. Leitura sincrona tambem evita
// o "flash": a tela pinta com o valor da ultima visita, mesmo padrao que o
// Layout ja usa para tema e menu.

const PREFIXO = "saasgl_segmento_tenant_";

export const CARRO = "carro";
export const MOTO = "moto";
export const EVENTO = "saasgl_segmento_atualizado";

// Mesma extracao de tenant que o Layout faz. Duplicada de proposito: mover
// isso para um modulo compartilhado obrigaria a mexer em arquivos que estao
// funcionando, e a regra aqui e nao reestruturar.
export function tenantAtual() {
  try {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!token) return (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1");
  } catch {
    return (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1";
  }
}

// Qualquer coisa que nao seja exatamente "moto" e carro. Falha segura: sem
// valor gravado, sem localStorage ou com lixo na chave, o sistema se comporta
// exatamente como sempre se comportou.
export function lerSegmento() {
  try {
    return localStorage.getItem(PREFIXO + tenantAtual()) === MOTO ? MOTO : CARRO;
  } catch {
    return CARRO;
  }
}

// So avisa a tela quando o valor REALMENTE muda -- senao cada visita de
// pagina dispararia um re-render inutil em todo mundo que escuta.
export function gravarSegmento(valor) {
  const novo = valor === MOTO ? MOTO : CARRO;
  try {
    const chave = PREFIXO + tenantAtual();
    if (localStorage.getItem(chave) === novo) return;
    localStorage.setItem(chave, novo);
    window.dispatchEvent(new Event(EVENTO));
  } catch {
    // Modo privado ou cota cheia: segue no padrao. Nunca quebra a tela.
  }
}

// Escolhe "<chave>_moto" quando a oficina e de moto E essa variante existe no
// dicionario. Se nao existir, devolve a chave original -- e por isso que
// nenhuma tela fica sem texto se eu esquecer de traduzir alguma.
export function chaveDoSegmento(i18n, chave, segmento) {
  if (segmento !== MOTO || typeof chave !== "string") return chave;
  const variante = chave + "_moto";
  if (i18n && typeof i18n.exists === "function" && i18n.exists(variante)) return variante;
  return chave;
}
